import BookingLink from "@/components/BookingLink";
import { Button } from "@/components/ui/button";

interface CTABandProps {
  headline?: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
}

const CTABand = ({
  headline = "Book a Quality & Data Diagnostic",
  description = "A focused session to assess your quality systems, data maturity and Ofsted readiness — with clear, prioritised recommendations.",
  buttonText = "Book Your Diagnostic",
  buttonLink = "/contact",
}: CTABandProps) => {
  return (
    <section className="bg-primary section-padding">
      <div className="container-narrow text-center">
        <h2 className="text-primary-foreground mb-4">{headline}</h2>
        <p className="text-primary-foreground/70 max-w-2xl mx-auto mb-8">
          {description}
        </p>
        <Button variant="cta" size="lg" asChild>
          <BookingLink>{buttonText}</BookingLink>
        </Button>
      </div>
    </section>
  );
};

export default CTABand;
